import classNames from 'classnames';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import FlightsPropTypes from '../../proptypes/flights';
import { getFlightTypeData } from '../../utils/flightUtils';
import FlightTypeSidebar from './FlightTypeSidebar';
import FlightsRouteSidebar from './FlightsRouteSidebar';
import { NO_CONCRETIZATION_FLIGHT_TYPE } from './constants';

const baseCls = 'checkout-sidebar-flight';

const FlightsItemSidebar = ({
  to,
  back,
  className,
  onClick,
  isBusinessFlight,
  isMobile,
  isDateChangable,
}) => {
  const toFlightTypeData = getFlightTypeData(to);
  const backFlightTypeData = getFlightTypeData(back);
  const noConcretizationFlightData = getFlightTypeData(
    NO_CONCRETIZATION_FLIGHT_TYPE,
  );
  const isFlightsTypeEqual = isEqual(toFlightTypeData, backFlightTypeData);

  const wrapperCls = classNames(baseCls, {
    [className]: !!className,
  });

  const { t } = useTranslation();

  const changableTimeMessage = t('checkout.sidebar.changableTime');

  const flightsRouteCls = classNames(`${baseCls}__item`, {
    'checkout-sidebar-button': true,
    'checkout-sidebar-button--business': isBusinessFlight && !isMobile, // в мобилке у бизнеса цвета не отличаются
  });

  return (
    <div className={wrapperCls}>
      <FlightTypeSidebar
        isFlightsTypeEqual={isFlightsTypeEqual}
        isMobile={isMobile}
        isDateChangable={isDateChangable}
        to={isDateChangable ? noConcretizationFlightData : toFlightTypeData}
        back={isDateChangable ? noConcretizationFlightData : backFlightTypeData}
      />

      <div className={`${baseCls}__details`}>
        <button onClick={onClick} type="button" className={flightsRouteCls}>
          <FlightsRouteSidebar
            data={to}
            isMobile={isMobile}
            isFlightsTypeEqual={isFlightsTypeEqual}
            isDateChangable={isDateChangable}
          />
        </button>

        <div className={`${baseCls}__separator--container`}>
          <div className={`${baseCls}__separator`} />
        </div>

        <button onClick={onClick} type="button" className={flightsRouteCls}>
          <FlightsRouteSidebar
            data={back}
            isMobile={isMobile}
            isFlightsTypeEqual={isFlightsTypeEqual}
            isDateChangable={isDateChangable}
          />
        </button>
      </div>
      {isDateChangable && <StyledMessage>{changableTimeMessage}</StyledMessage>}
    </div>
  );
};

const StyledMessage = styled.div`
  color: #17181a;
  font-family: 'ONYOneFont', 'Helvetica', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

FlightsItemSidebar.defaultProps = {
  isMobile: false,
};

FlightsItemSidebar.propTypes = {
  to: FlightsPropTypes.to.isRequired,
  back: FlightsPropTypes.back.isRequired,
  className: PropTypes.string,
  isBusinessFlight: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};

FlightsItemSidebar.defaultProps = {
  className: null,
};

export default FlightsItemSidebar;
